<template>
  <div class="relative flex h-full min-h-0 flex-col">
    <NoData
      v-if="bleAnchors.length === 0"
      class="min-h-0 flex-1"
      title="There are no Anchors"
      subtitle="Your anchor list is empty"
    />
    <div
      v-else
      class="flex min-h-0 flex-1 flex-col"
      :class="{
        'pb-[86px] md:pb-[102px]': $can('manage', 'Anchors'),
      }"
    >
      <div class="h-12 shrink-0 bg-gpx_gray-900" />
      <DynamicScroller
        class="min-h-0 flex-1"
        :items="props.bleAnchors"
        :min-item-size="98"
        key-field="id"
        listClass="ds-ble-anchor-list"
        itemClass="ds-ble-anchor-list-item"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :size-dependencies="[item.name]"
            :data-index="index"
          >
            <div class="border-b border-gpx_gray-900">
              <div class="bg-white hover:bg-gpx_gray-900">
                <div class="flex py-[15px] pl-6 pr-[48px] md:pl-12 md:pr-[56px]">
                  <BleAnchorListItem
                    class="w-full overflow-hidden"
                    :ble-anchor="item"
                    :edit-item-id="editItemId"
                    @setEditItemId="setEditItemId"
                    @resetEditItemId="resetEditItemId"
                  />
                </div>
              </div>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
    </div>
    <CommonBottomButtonSection v-if="$can('manage', 'Anchors')">
      <Button
        class="w-full"
        icon="SquaresPlusIcon"
        @click="handleCreateClick"
      >
        New Anchor
      </Button>
    </CommonBottomButtonSection>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import NoData from '@/components/_common/NoData.vue';
import CommonBottomButtonSection from '@/components/_common/CommonBottomButtonSection.vue';
import BleAnchorListItem from './BleAnchorListItem.vue';
import { useSetItemIdOnDynamicList } from '@/use/use-set-item-id-on-recycle-list';
import * as events from '@/events';

const props = defineProps({
  bleAnchors: Array,
});

const store = useStore();

const { editItemId, setEditItemId, resetEditItemId } =
  useSetItemIdOnDynamicList('ble-anchor');

function handleCreateClick() {
  store.dispatch('modal/open', {
    name: 'GeofenceCreateBleAnchorModal',
  });
}

onMounted(() => {
  events.trigger(events.names.ALL_BLE_ANCHORS_VIEWED);
});
</script>

<style>
.ds-ble-anchor-list {
  @apply !overflow-visible;
}
</style>
